import React, { Component } from 'react';
import { getElementsAndStyles } from '~/services/domService';
import { FONT_COLORS } from '~/constants/colorsList';
import ColorsList from '@/SelectList/ColorsList';
import SelectList from '@/SelectList';
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export class FontColor extends Component {
  constructor(props = { featureId }){
    super(props);
    this.state = {
      initialDom: getElementsAndStyles({stylePropery: 'color'}),
      colors: FONT_COLORS
    }
  }
  resetFontColor(){
    for (let item of this.state.initialDom) {
      if (item.color) {
        item.$element.style.color = item.color;
      } else {
        item.$element.style.removeProperty('color');
      }
    }
  }
  changeFontColor(hex){
    for (let item of this.state.initialDom) {
      item.$element.style.color = hex;
    }
  }
  render(){
    let { colors } = this.state;
    let { featureId } = this.props;
    let { getFeatureById, setFeatureOptions } = this.props.featuresListStore;
    let feature = getFeatureById(featureId);

    let selectListProps = {
      list: colors,
      selectedId: feature.options.selectedId,
      LayoutComponent: ColorsList,
      onReset: () => {
        this.resetFontColor();
        setFeatureOptions(featureId, {
          selectedId: null
        });
      },
      onChoise: (color) => {
        this.changeFontColor(color.hex);
        setFeatureOptions(featureId, {
          selectedId: color.id
        });
      }
    }
    return (
      <SelectList { ...selectListProps } />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Feature/FeatureActions/FontColor/index.js